module.exports = __webpack_public_path__ + "static/diy_recipe_tiny_turtles_thumbnail-6f4e4f7eaff7b9a644ef73d5ea190631.jpg";